import { JobPlateTestLoad } from "./jobPlateTestLoad";

export class platebearingtest {
  cbr: number;
  createdAt;
  customerReference: string;
  force: number;
  id: string;
  job: any;
  jobId: string;
  jobPlateTestLoads: JobPlateTestLoad[];
  k: number;
  lineItemNumber: number;
  locationReference: string;
  material: any;
  materialId: number;
  plateTestType: any;
  plateTestTypeId: string;
  reason_For_ReIssue: string;
  remarks: string;
  typeOfReactionLoad: string;
  version_No: number;
}
